import { Link } from '@trg/tlw-ui-component';
import { logoPng } from '../../common';
import { useLayoutStore } from '../../layout';
import { useHeaderData } from '../hooks';
import { selectLogo } from '../api';

export function Logo() {
  const isDesktop = useLayoutStore.use.isDesktop();

  const data = useHeaderData();
  const logo = selectLogo(data);

  const imgUrl = isDesktop ? logo?.imageMediasUrl : logo?.mobileImageMediasUrl;

  return (
    <Link href={logo?.link} target={logo?.linkTarget}>
      <img
        className="tlw-w-[44px]"
        src={imgUrl || logoPng}
        alt=""
        onError={(e) => (e.currentTarget.src = logoPng)}
      />
    </Link>
  );
}
